<script setup lang="ts">
// A German article, /de/blog/<slug> (pages/de-blog/index.vue).
false && /*#__PURE__*/ defineI18nRoute({ locales: ['de'], paths: { de: '/blog/[slug]' } })

definePageMeta({
  layout: 'blog',
  blogLocale: 'de',
})
</script>

<template>
  <BlogArticle locale="de" />
</template>
